module.exports = __webpack_public_path__ + "img/01-T.dfcdd185.png";